import React, {useEffect} from 'react'
import Navbar from '../component/Navbar';
import Fotter from '../component/Fotter';
const Privacypolicy = () => {
    useEffect(() => {
        document.title = 'AN-TECH - PRIVACY POLICY'; // Change the title as desired
        // Make sure to replace 'Your Website Name' with your actual website name
      }, []);
  return (
   <>
   <Navbar/>
   <div className='bg-gray-800 py-24'>

<header class="py-4">
    <div class="container mx-auto text-white text-center">
        <h1 class="text-3xl font-semibold">AN-TECH Privacy Policy</h1>
    </div>
</header>


<section className="bg-gray-900 text-white body-font">
      <div className="container px-2 py-24 mx-auto">
        <div className="xl:w-1/2 lg:w-3/4 w-full mx-auto text-center">

          <p className="leading-relaxed text-lg">
            <span className='text-indigo-500 text-2xl font-bold'>1. Introduction:</span>
            Welcome to AN-TECH, a web development, graphics design, video editing, product promotion, and course promotion agency. At AN-TECH, we are committed to protecting your privacy and ensuring that your personal information is handled responsibly. This Privacy Policy outlines our practices regarding the collection, use, and sharing of your information when you interact with our website, products, or services.
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>2. Information We Collect: </span>
            We may collect the following types of information:
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>   2.1. Personal Information:</span>
         

Name
Email address
Phone number

            <br />
            <span className='text-indigo-500 text-2xl font-bold'>2.2. Non-Personal Information: </span>
            Browser type and version
Operating system
IP address
Usage data e.g., pages visited, actions taken
Cookies and similar technologies please see our Cookie Policy
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>3. How We Use Your Information </span>
            We may use your information for the following purposes:
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>3.1. Providing Services: </span>
            Delivering web development, graphics design, video editing, product promotion, and course promotion services to you.
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>3.2. Communication: </span>
            Sending important information, updates, and marketing materials related to our services.
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>3.3. Customer Support: </span>
            Responding to your inquiries, requests, and resolving issues.
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>3.4. Analytics and Improvement: </span>
            Analyzing user behavior to improve our website and services.
Measuring the effectiveness of our marketing efforts.
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>3.5. Legal Obligations: </span>
            Complying with legal requirements and obligations.
          </p>
          <span className='text-indigo-500 text-2xl font-bold'>4. Data Sharing </span>
          We may share your information with third parties for the following purposes:
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>4.1. Service Providers:

</span>
Working with trusted service providers who assist us in delivering our services.
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>4.2. Legal Requirements: </span>
            Complying with applicable laws and regulations, or in response to a legal request.
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>4.3. Business Transactions: </span>
            In the event of a merger, acquisition, or sale of assets, your information may be transferred.
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>4.4. Marketing and Advertising: </span>
            Sharing non-personal and anonymized data with marketing partners or advertisers for promotional purposes.
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>5. Your Rights and Choices</span>
            You have the following rights regarding your personal information:
            <br />
            <span className='text-indigo-500 text-2xl font-bold'>6. Contact Us</span>
            If you have any questions, concerns, or requests related to this Privacy Policy, please contact us at <p>Contact us at: <a href="mailto:antech439@gmail.com">antech439@gmail.com</a></p>
            <br />
        </div>
      </div>
    </section>

   </div>
   <Fotter/>
   </>
  )
}

export default Privacypolicy